import React, { useState } from 'react'
import './Footer.css'
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaGoogle, FaEnvelope, FaPhone } from 'react-icons/fa';
import message from '../assets/images/mesg.png';
import call from '../assets/images/call.png';
import Contact from '../page/Contact';

const Footer = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section - Logo and Description */}
        <div className="footer-brand">
          <div className="footer-logo">
            <img src="/Brown and Orange Event Management Logo.svg" alt="The Event House" className="logo-image" />
          </div>
          <p className="footer-description">
            A modern event management company focused on meaningful experiences.
          </p>
          <div className="social-icons">
            <a href="https://www.facebook.com/eventhouse.in" target="_blank" className="social-icon" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com/eventhouse.in" target="_blank" className="social-icon" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="#" className="social-icon" target="_blank" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="#" className="social-icon" target="_blank" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
            <a href="#" className="social-icon" target="_blank" aria-label="Google">
              <FaGoogle />
            </a>
          </div>
        </div>

        <div className="footr-links">
          {/* Quick Links Section 1 */}
        <div className="footer-links">
          <h3 className="footer-title">Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/events">About Us</a></li>
            <li>
              <button
                type="button"
                className="footer-link-button"
                onClick={() => setIsContactOpen(true)}
              >
                Contact Us
              </button>
            </li>
            
            <li><a href="#booking-section">How it Works</a></li>
            <li><a href="/events">Events</a></li>

          </ul>
        </div>

        {/* Quick Links Section 2 */}
        <div className="footer-links">
          <h3 className="footer-title">Usefull Links</h3>
          <ul>
            <li><a href="/PrivacyPolicy">Privacy Policy</a></li>
            <li><a href="/TermsService">Terms of Service</a></li>
            <li><a href="/RefundPolicy">Refund Policy</a></li>
            {/* <li><a href="#how-it-works">How it Works</a></li>
            <li><a href="#events">Events</a></li> */}
          </ul>
        </div>
        </div>

        {/* Contact Section */}
        <div className="footer-contact">
          <h3 className="footer-title">Contact Us</h3>
          <ul>
            <li>
              <img src={message} alt="message" className='iconss' />
              <a href="mailto:info@eventhouse.in" className="contact-link">
                info@eventhouse.in
              </a>
            </li>
            <li>
              <img src={call} alt="message"   className='iconss'/>

              <a href="tel:+917986427522" className="contact-link">

                +91-7986427522
              </a>
            </li>
          </ul>

          {/* App Store Buttons */}
          {/* <div className="app-buttons">
            <a href="#" className="app-button" aria-label="Download on App Store">
              <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" />
            </a>
            <a href="#" className="app-button" aria-label="Get it on Google Play">
              <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" />
            </a>
          </div> */}
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-bottom">
        <div className="footer-divider"></div>
        <p className="copyright">
          © Copyright 2025 | Designed and Developed by <span className="company-name"> 
            <a href='https://indraq.com/' target="_blank">IndraQ Innovations Private Limited. </a> </span>
        </p>
      </div>
      {isContactOpen && <Contact onClose={() => setIsContactOpen(false)} />}
    </footer>
  )
}

export default Footer
